// Production builds stay quiet in the browser console: console.log / info / debug become no-ops
// (the app has ~110 development diagnostics such as "[App] Initial load useEffect running").
// console.warn and console.error stay, so real problems are still visible. Builds with
// REACT_APP_ENABLE_DEBUG=true (dev deploys) and local development keep every log.
const QUIET_METHODS = ['log', 'info', 'debug']

export function quietConsole(env = process.env, target = console) {
  if (env.NODE_ENV !== 'production' || env.REACT_APP_ENABLE_DEBUG === 'true') return false
  QUIET_METHODS.forEach((method) => {
    target[method] = () => {}
  })
  return true
}

quietConsole()
